import { useEffect, useLayoutEffect } from "react";

import { StatsigClient, StatsigUser } from "@statsig/js-client";
import { StatsigProvider } from "@statsig/react-bindings";

import useAuth, { User } from "@app/common/auth/useAuth";
import Config from "@app/config";

const DEFAULT_STATSIG_USER: StatsigUser = {};

const statsigClient = new StatsigClient(
  Config.tracking.STATSIG_KEY,
  DEFAULT_STATSIG_USER,
  {
    environment: {
      tier: import.meta.env.VITE_APP_STAGE ?? "development",
    },
    networkConfig: {
      preventAllNetworkTraffic:
        import.meta.env.VITE_APP_STAGE === "development" ||
        import.meta.env.VITE_APP_DISABLE_STATSIG == "true",
    },
  }
);
statsigClient.initializeSync();

const getStatsigUser = (user: User | null) => {
  if (!user) {
    return DEFAULT_STATSIG_USER;
  }
  return { userID: user.id, email: user.email };
};

const ExperimentProvider = ({ children }: { children: React.ReactNode }) => {
  const { user, impersonating } = useAuth();

  useLayoutEffect(() => {
    statsigClient.updateUserSync(getStatsigUser(user));
  }, [user]);

  useEffect(() => {
    statsigClient.updateRuntimeOptions({
      disableLogging: impersonating,
    });
  }, [impersonating]);

  return <StatsigProvider client={statsigClient}>{children}</StatsigProvider>;
};

export default ExperimentProvider;
